import { render, staticRenderFns } from "./ItemGenerate.vue?vue&type=template&id=eab985a4&scoped=true&"
import script from "./ItemGenerate.vue?vue&type=script&lang=js&"
export * from "./ItemGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab985a4",
  null
  
)

export default component.exports